import { Link } from "react-router-dom";
import { ArticleCategory, CATEGORY_CONFIG } from "@/data/mockData";

interface CategoryTabsProps {
  active: ArticleCategory | "all";
  onChange: (cat: ArticleCategory | "all") => void;
}

const tabs: { key: ArticleCategory | "all"; label: string; archiveHref?: string }[] = [
  { key: "all", label: "All" },
  { key: "expose", label: "Exposés", archiveHref: "/category/exposes" },
  { key: "prop_firm", label: "Prop Firms", archiveHref: "/category/prop-firms" },
  { key: "broker", label: "Brokers", archiveHref: "/category/brokers" },
  { key: "regulation", label: "Regulations", archiveHref: "/category/regulation" },
  { key: "review", label: "Reviews", archiveHref: "/category/reviews" },
  { key: "comparison", label: "Comparisons", archiveHref: "/category/comparisons" },
  { key: "awards", label: "Awards", archiveHref: "/category/awards" },
  { key: "market_analysis", label: "Analysis", archiveHref: "/category/analysis" },
  { key: "event", label: "Events", archiveHref: "/category/events" },
  { key: "fintech", label: "Fintech", archiveHref: "/category/fintech" },
];

const CategoryTabs = ({ active, onChange }: CategoryTabsProps) => {
  return (
    <div className="flex items-center gap-1 overflow-x-auto pb-1 scrollbar-none" style={{ WebkitOverflowScrolling: 'touch' }}>
      {tabs.map((tab) => {
        const isActive = active === tab.key;
        const config = tab.key !== "all" ? CATEGORY_CONFIG[tab.key] : null;

        return (
          <button
            key={tab.key}
            onClick={() => onChange(tab.key)}
            className={`relative shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 border
              ${isActive
                ? config
                  ? `${config.bgClass} ${config.textClass} border-current/20`
                  : "bg-primary text-primary-foreground border-primary"
                : "text-muted-foreground border-border hover:text-foreground hover:border-muted-foreground"
              }`}
          >
            {tab.label}
          </button>
        );
      })}

      {/* View All link for the active category */}
      {active !== "all" && tabs.find((t) => t.key === active)?.archiveHref && (
        <Link
          to={tabs.find((t) => t.key === active)!.archiveHref!}
          className="shrink-0 ml-2 px-4 py-2 rounded-full text-sm font-medium text-primary border border-primary/30 hover:bg-primary/10 transition-colors"
        >
          View All →
        </Link>
      )}
    </div>
  );
};

export default CategoryTabs;
